export const getSexObjectByName = (sex: string): { id: number; name: string } => {
  let sexObject = {
    id: 1,
    name: 'INDISTINTO'
  }

  if (sex === 'MASCULINO') {
    sexObject = {
      id: 2,
      name: 'HOMBRE'
    }
  }
  if (sex === 'FEMENINO') {
    sexObject = {
      id: 3,
      name: 'MUJER'
    }
  }

  return sexObject
}
